// extracted by mini-css-extract-plugin
export default {"about":"about-stats_about__HWOp3","content":"about-stats_content__O9vBq","first":"about-stats_first__oyHKK","second":"about-stats_second__hUGzt","third":"about-stats_third__jj5gw"};